import "@styles/main.scss"

// Temporary dependencies until migrated to other projects in shared theme

// Supports weights 300-800
import "@fontsource-variable/open-sans"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"

import { setGlobalTokens } from "@ehi/styles"

setGlobalTokens()
